import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TextFieldData from "../../GeneralDisclosure/TextFiledData";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  TableContainer,
  Paper,
  Typography,
  TextField,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  MenuItem,
  Select,
  IconButton,
  FormHelperText,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EastIcon from "@mui/icons-material/East";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import styles from "../../../../styles/gri/general.module.css";

const AddTablesSelected = ({
  title,
  addTables,
  setaddTables,
  errors,
  setErrors,
  inputData,
  handleAdd,
  setList,
  units,
  disabled,
  hide
}) => {
  const [deleteDilog, setDeleteDialog] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  // true means last row incomplete → Add button disabled by default
  const [isFilleds, setIsFilled] = useState(true);
  const Upstream = [
    "Purchased goods and services",
    "Capital goods",
    "Fuel- and energy-related activities ",
    "Upstream transportation and distribution",
    "Waste generated in operations",
    "Business travel",
    "Employee commuting",
    "Upstream leased assets",
    "Other upstream",
  ];
  const Downstream = [
    "Downstream transportation and distribution",
    "Processing of sold products",
    " Use of sold products",
    "End-of-life treatment of sold products",
    " Downstream leased assets",
    "Franchises",
    "Investments",
    "Other downstream",
  ];
  const handleChangeTable = (e, index) => {
    const { name, value } = e.target;
    console.log(name, value, index, "handleChangeTable");
    setaddTables((prev) => {
      const newData = [...prev]; // Create a shallow copy of the array
      newData[index] = {
        ...newData[index], // Copy the object at the given index

        [name]: value,
        // Update the specific field dynamically
      };
      return newData;
      setList();
    });
    // setaddTables((prev) =>
    //     prev.map((row, rowIndex) =>
    //         console.log(row,rowIndex,"setAddTables")
    //     //   rowIndex === index
    //         // ? { ...row, [name]: value } // Update only the matching row
    //     //     : row // Keep other rows unchanged
    //     ))
  };

  useEffect(() => {
    checkIfAdded();
  }, [addTables, inputData]); // Run only when addTables or inputData change

  // Also validate on mount to correctly set initial button state
  useEffect(() => {
    checkIfAdded();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const flattenObject = (obj, prefix = "") => {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      const newKey = prefix ? `${prefix}.${key}` : key;
      if (typeof value === "object" && value !== null) {
        Object.assign(acc, flattenObject(value, newKey)); // Recursively flatten nested objects
      } else {
        acc[newKey] = value;
      }
      return acc;
    }, {});
  };

  const isFilled = (value) => {
    return (
      value !== undefined &&
      value !== "" &&
      value !== null &&
      !(Array.isArray(value) && value.length === 0)
    );
  };

  const checkIfAdded = () => {
    if (!Array.isArray(addTables) || addTables.length === 0) {
      setIsFilled(true);
      return;
    }

    // Only validate the last row for enabling the Add button
    const last = addTables[addTables.length - 1];
    let incomplete = false;

    // If inputData provides fields, use those as required (except computed like percentage)
    const fields = (inputData?.fields || []);
    for (const field of fields) {
      const fieldName = field?.fieldName;
      console.log(fieldName,"fieldName")
      if (!fieldName) continue;
      // Skip auto/computed fields
      if (fieldName === "percentage" || fieldName === "unit") continue;
      // Conditional: outsideBoundry only required when category present
      if (fieldName === "outsideBoundry" && !last?.category) continue;
      const val = last?.[fieldName];
      if (val === "" || val === null || val === undefined) {
        incomplete = true;
        break;
      }
    }

    setIsFilled(incomplete);
  };

  const handleChangeNumberTable = (e, index) => {
    const { name, value } = e.target;
    if (!/^\d*$/.test(value)) return;
    console.log(name, value, index, "handleChangeTable Number");
    setaddTables((prev) => {
      const newData = [...prev]; // Create a shallow copy of the array
      newData[index] = {
        ...newData[index], // Copy the object at the given index

        [name]: value,
        // Update the specific field dynamically
      };
      return newData;
    });
    // setaddTables((prev) =>
    //     prev.map((row, rowIndex) =>
    //         console.log(row,rowIndex,"setAddTables")
    //     //   rowIndex === index
    //         // ? { ...row, [name]: value } // Update only the matching row
    //     //     : row // Keep other rows unchanged
    //     ))
  };

  const handleDeleteRow = () => {
    console.log(deleteIndex, "delete country");
    setDeleteDialog(false);
    setaddTables((prev) => prev.filter((_, i) => i !== deleteIndex));
  };

  return (
    <>
      <p className={styles.ques_heading}>{title}</p>

      <TableContainer
        component={Paper}
        sx={{
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          mt: "1rem",
          borderRadius: "10px",
          width: "98.5%",
        }}
      >
        <Table sx={{ border: "1px solid #ddd", borderRadius: "10px", tableLayout: "fixed", width: "100%" }}>
          <TableHead>
            <TableRow
              sx={{
                borderRadius: "10px",
                backgroundColor: "#1C486B",
                border: "1px solid #ddd",
              }}
            >
              <TableCell
                sx={{
                  border: "1px solid #ddd",
                  fontWeight: "bold",
                  color: "#FFFFFF",
                  width: "6%",
                }}
              >
                {"S. No."}
              </TableCell>
              {inputData?.fields?.map((field) => (
                <TableCell
                  key={field.fieldName}
                  sx={{
                    border: "1px solid #ddd",
                    fontWeight: "bold",
                    color: "#FFFFFF",
                    width: field?.width ? field?.width : "12%",
                  }}
                >
                  {field.title}
                </TableCell>
              ))}
              <TableCell
                sx={{
                  border: "1px solid #ddd",
                  fontWeight: "bold",
                  color: "#FFFFFF",
                  width: "6%",
                }}
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {addTables.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {/* Serial Number */}
                <TableCell sx={{textAlign:"center",width:"6%"}}>{rowIndex + 1}.</TableCell>

                {inputData?.fields?.map((field, index) => (
                  <TableCell
                    sx={{
                      border: "1px solid #DBDBDB",
                      py: "0.5rem",
                      width: inputData?.colwidth ? inputData?.colwidth : "63%",
                      maxWidth: "100%",
                      background: "white",
                      whiteSpace: "nowrap", // Prevent wrapping
                      overflow: "hidden", // Hide overflow
                      textOverflow: "ellipsis",
                    }}
                    key={index}
                  >
                    {field.type === "select" ? (
                      <Select
                        sx={{
                          height: "2rem",
                          border: "none",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          minWidth: 0,
                          width: "100%",
                          boxShadow: "none", // Ensures no shadow appears
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none", // Removes default MUI border
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            border: "none", // Ensures no border on hover
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            border: "none", // Removes border on focus
                          },
                        }}
                        name={field.fieldName}
                        value={
                          field.fieldName === "unit"
                            ? units
                            : row?.[field.fieldName] || ""
                        }
                        onChange={(e) => handleChangeTable(e, rowIndex)}
                        displayEmpty
                        size="small"
                        fullWidth
                        disabled={
                          disabled ||
                          field?.disabled ||
                          (row?.category === "" &&
                          field.fieldName === "outsideBoundry"
                            ? true
                            : false)
                        }
                        // disabled={!data?.[DropDownData?.fieldName]?.[list?.fields]?.active}
                      >
                        <MenuItem value="">
                          <em>Select</em>
                        </MenuItem>
                        {field.fieldName === "outsideBoundry"
                          ? row?.category === "Upstream"
                            ? Upstream?.map((u, index) => (
                                <MenuItem key={index} value={u}>
                                  {u}
                                </MenuItem>
                              ))
                            : row?.category === "Downstream"
                            ? Downstream?.map((u, index) => (
                                <MenuItem key={index} value={u}>
                                  {u}
                                </MenuItem>
                              ))
                            : null
                          : field?.list?.map((data, index) => (
                              <MenuItem key={index} value={data}>
                                {data}
                              </MenuItem>
                            ))}
                      </Select>
                    ) : (
                      <TextField
                        sx={{ width: "100%" }}
                        name={field.fieldName}
                        value={row?.[field.fieldName] || ""}
                        placeholder={field?.type==="number"? "Enter Number":"Enter Text"}
                        // type="text"
                        multiline
                        minRows={1}
                        size="small"
                        variant="standard"
                        // inputProps={{ style: { minWidth: 0 } }}
                        disabled={disabled || field.fieldName === "percentage"?true:false}
                        InputProps={{ disableUnderline: true }}
                        onChange={(e) =>
                          field.type === "number"
                            ? handleChangeNumberTable(e, rowIndex)
                            : field.fieldName === "percentage"
                            ? ""
                            : handleChangeTable(e, rowIndex)
                        }
                      />
                    )}
                  </TableCell>
                ))}

                {/* Delete Row Button */}
                <TableCell>
                  <Dialog
                    open={deleteDilog}
                    onClose={() => {setDeleteDialog(false);
                       }}
                  >
                    <DialogTitle>Confirm Delete</DialogTitle>
                    <DialogContent>
                      <DialogContentText>
                        Do you really want to delete this entry?
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        onClick={() => setDeleteDialog(false)}
                        color="primary"
                      >
                        Cancel
                      </Button>
                      <Button
                        // onClick={handleDeleteAggree}
                        onClick={() => handleDeleteRow()}
                        color="secondary"
                      >
                        Confirm
                      </Button>
                    </DialogActions>
                  </Dialog>
                  <IconButton
                    onClick={() =>{ setDeleteDialog(true); setDeleteIndex(rowIndex)}}
                    color="error"
                    disabled={disabled}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Add Row Button */}
      {!hide &&
      <Box textAlign="right">
        <Button
          disabled={isFilleds || false || disabled}
          variant="contained"
          onClick={handleAdd}
          sx={{
            mt: "1rem",
            backgroundColor: "#1C486B",
            color: "white",
          }}
        >
          <AddIcon />
          Add
        </Button>
      </Box>
}
    </>
  );
};
export default AddTablesSelected;
